import * as React from "react";
import styled from "styled-components";
import { ActionList, Checkbox, spacing } from "@conserveit/blocks";
import {
  SettingsBoxWrapper as BoxWrapper,
  BoxHeader,
  BoxHeading,
} from "../ProjectSettings.styles";
import { useRuleSettings } from "../hooks/useRuleSettings";
import { RuleSetting } from "../../../context/settings/types";
import { RuleName, CheckboxWrap } from "./Box.styles";
import { PriorityControl } from "./PriorityControl";
import { InsightType } from "../../../utils/routes";

interface Props {
  selectedRule?: RuleSetting;
}
export const OPTIONS = [
  { label: "P1", value: 1 },
  { label: "P2", value: 2 },
  { label: "P3", value: 3 },
];

export function getPriorityValue(priority: number, insightType: InsightType) {
  if (insightType === InsightType.Insights) {
    return priority;
  }

  let index = OPTIONS.findIndex((item) => item.value === priority);
  if (index === -1) {
    index = 0;
  }

  return OPTIONS[index].value;
}

const Content = styled(ActionList)`
  padding: ${spacing.tight};
`;

const SettingsBox: React.FC<Props> = ({ selectedRule }) => {
  const { checked, handleCheck, updatePriority, insightType } =
    useRuleSettings();
  const handlePriority = React.useCallback(
    (option: number) => {
      const updated = { ...selectedRule, priority: option };
      updatePriority(updated as RuleSetting);
    },
    [selectedRule]
  );

  // tslint:disable-next-line: strict-type-predicates
  const isActive = selectedRule && checked[selectedRule.rule.id] !== undefined;
  const checkboxLabel = isActive ? "Active" : "Inactive";
  return (
    <BoxWrapper>
      <BoxHeader>
        <BoxHeading>Insight Configuration</BoxHeading>
      </BoxHeader>
      {selectedRule && (
        <Content>
          <RuleName>{selectedRule.rule.name}</RuleName>
          <CheckboxWrap>
            <Checkbox
              label={checkboxLabel}
              // tslint:disable-next-line: strict-type-predicates
              checked={checked[selectedRule.rule.id] !== undefined}
              name="SelectedRuleCheckbox"
              onChange={handleCheck(selectedRule)}
            />
          </CheckboxWrap>
          <PriorityControl
            key={`${selectedRule.rule.id}`}
            active={getPriorityValue(selectedRule.priority, insightType)}
            onChange={handlePriority}
            insightType={insightType}
          />
        </Content>
      )}
    </BoxWrapper>
  );
};

export default SettingsBox;
